"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7607],{

/***/ 37607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pro_tools_Keystats; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/LandingPage/index.ts + 8 modules
var LandingPage = __webpack_require__(55781);
// EXTERNAL MODULE: ./src/features/pro-tools/constants.ts
var constants = __webpack_require__(23443);
;// CONCATENATED MODULE: ./src/features/pro-tools/Keystats/content.ts
var keystatsContents = [
    {
        title: "Valuasi Perusahaan",
        description: "Pelajari data valuasi dari perusahaan untuk mengetahui apakah perusahaan tersebut tergolong murah (undervalued) atau mahal (overvalued). Data valuasi yang disajikan pada Keystats seperti Current PE ratio (Annualized & TTM), IHSG PE Ratio TTM, Earnings Yield, Current Price to Sales, Current Price to Book Value, EV to EBIT, PEG ratio (Current, 3Yr & Forward).",
        image: "Keystats_Valuation_Blue.jpg"
    },
    {
        title: "Arus Kas",
        description: "Pelajari likuiditas, solvabilitas dan fleksibilitas keuangan perusahaan dengan melihat cash flow from operation, cash flow from investing & cash flow from financing, juga capital expenditure dan free cash flow (TTM).",
        image: "Keystats_Cash_Flow_Blue.jpg"
    },
    {
        title: "Level Hutang",
        description: "Cari tahu keadaan kesehatan perusahaan dengan melihat level hutang dari rasio-rasio Solvency seperti Altman Z-score, Current ratio, Quick ratio, Debt to Equity ratio, LT Debt to Equity, Total Liabilities to Equity, Total Debt to Total Asset, Financial Leverage, Interest Coverage dan Free Cash Flow (Quarter).",
        image: "Keystats_Solvency_Blue.jpg"
    },
    {
        title: "Dividend",
        description: "Lihat informasi terkait pembagian dividend perusahaan, berapa jumlah dividend per share yang dibagikan, berapa payout ratio, berapa besar dividend yield dan kapan ex date pembagian dividend terakhir. Lihat juga data terkait Stock Split dan Stock Bonus.",
        image: "Keystats_Deviden_Blue.jpg"
    }, 
];
/* harmony default export */ var content = (keystatsContents);

;// CONCATENATED MODULE: ./src/features/pro-tools/Keystats/index.tsx




function Keystats() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPage/* PageHeader */.mr, {
                title: "Keystats",
                description: "Tangkap peluang pasar lebih cepat dengan ringkasan kinerja yang disajikan dengan menarik"
            }),
            content.map(function(content, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPage/* SectionBrowser */.Dr, {
                    title: content.title,
                    image: "".concat(constants/* ASSET_URL */.Z).concat(content.image),
                    description: content.description,
                    reverse: index % 2 === 0
                });
            })
        ]
    });
}
/* harmony default export */ var pro_tools_Keystats = (Keystats);


/***/ })

}]);